"use strict";

import { ModalService } from './service';
import { OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalFooterComponent } from './modalfooter/component';
import { ModalAction } from './modalfooter/modalaction';
import {Tools} from "linkurious-shared";

export interface OnTriggerValidation {
  triggerValidation(): Promise<any>;
}

export interface OnTriggerCancellation {
  triggerValidation(): Promise<any>
}

export interface OnTriggerHideValidation {
  triggerHideValidation(): boolean;
}

export interface OnTriggerDisableValidation {
  triggerDisableValidation(): boolean;
}

export interface OnTriggerHideDismiss {
  triggerHideDismiss(): boolean;
}

export interface OnTriggerDisableDismiss {
  triggerDisableDismiss(): boolean;
}

export abstract class AbstractModalComponent implements OnDestroy, OnInit {

  @ViewChild('modalHeader', {read: TemplateRef}) modalHeader;
  @ViewChild('modalBody', {read: TemplateRef}) modalBody;
  @ViewChild('modalActions', {read: TemplateRef}) modalActions: TemplateRef<ModalFooterComponent>;

  public actions: Array<ModalAction> = [];
  public onValidate: Function;
  public onDismiss: Function;
  public onHiddenValidation: Function;
  public onDisableValidation: Function;
  public onHiddenDismiss: Function;
  public onDisableDismiss: Function;


  protected constructor(
    protected _modal: ModalService
  ) {}

  public triggerValidation(): Promise<void> {
    if ( Tools.isDefined(this.onValidate) ) {
      return this.onValidate();
    }
  }

  public triggerCancellation(): Promise<void> {
    if ( Tools.isDefined(this.onDismiss) ) {
      return this.onDismiss();
    }
  }

  public triggerHideValidation(): boolean {
    if ( Tools.isDefined(this.onHiddenValidation) ) {
      return this.onHiddenValidation();
    }
  }

  public triggerDisableValidation(): boolean {
    if ( Tools.isDefined(this.onDisableValidation) ) {
      return this.onDisableValidation();
    }
  }

  public triggerHideDismiss(): boolean {
    if ( Tools.isDefined(this.onHiddenDismiss) ) {
      return this.onHiddenDismiss();
    }
  }

  public triggerDisableDismiss(): boolean {
    if ( Tools.isDefined(this.onDisableDismiss) ) {
      return this.onDisableDismiss();
    }
  }

  public ngOnDestroy() {}

  public ngOnInit() {};

  public close(e?: MouseEvent): void {
    if ( e ) {
      e.preventDefault();
      e.stopPropagation();
    }
    let dismissAction = this.actions.find(action => action.type === 'dismiss');
    if ( dismissAction ) {
      dismissAction.onClick();
    }
    this._modal.close();
  }
}
